// src/i18n/platform.ts —— 06 admin-console C-13（风控两页签）/ C-20 / C-21 / C-22 文案包（公告·工单·FAQ / 管理员账号 / 权限与角色；经 PageDef.i18n 挂入 table 域字典，TD-849）。
// 06 给出文案的键逐字取 06（含 Toast 映射表）；06 未给英文或未给键名的标「本计划定稿」（W-7 回写）；06 未给键名的标签与错误文案用 adm 前缀自造键。
import type { I18nPack } from '../../../shared/src/dc';

export const I18N_PLATFORM: I18nPack = {
  zh: {
    // C-13 风控规则 / 命中记录
    ruleBuiltin: '内置·硬执行',
    ruleAnchorTip: '阈值在系统参数 {key} 配置', // 06 占位 {键名} → {key}（interpolate 只识别 \w 占位名）
    ruleAlwaysOn: '内置规则恒生效',
    // C-20 公告 / 工单 / FAQ
    stOffline: '已下线',
    cSortOrder: '排序',
    ticketThread: '工单消息',
    senderUser: '用户',
    senderAdmin: '客服 {account}',
    replyPh: '填写回复内容',
    aReply: '回复',
    toastReplied: '回复已发送',
    admBody: '正文', // 06 C-20 表单「正文 (中文) / 正文 (EN)」
    admPublishedAt: '发布时间', // 06 C-20 抽屉「公告另加 发布时间」
    admSubmitter: '提交人', // 06 C-20 工单抽屉字段格
    admRefTx: '关联交易', // 06 C-20 工单抽屉字段格
    admErrSortOrder: '排序须为不小于 0 的整数', // 06 C-20 sort_order 校验「整数 ≥0」
    // C-21 管理员账号
    st2faUnbound: '未绑定',
    reset2faTitle: '重置 2FA',
    reset2faText: '将清除该管理员的动态验证码绑定并使其全部会话下线，下次登录需重新绑定 2FA。',
    toastReset2fa: '已重置该管理员 2FA，对方下次登录需重新绑定', // 本计划定稿（W-7）
    admErrPwdPolicy: '密码须为 8–20 位且同时包含字母与数字', // 06 C-21 重置密码「≥8 位含字母数字」（07 §3，≤20）
    admErrLastSuper: '至少需保留一名启用中的超级管理员', // 1012 data.reason=last_super_admin（spec §4.5 超管边界）
    // C-22 权限与角色
    errRoleInUse: '该角色仍有成员，无法删除',
    admErrSuperLocked: '超级管理员角色不可删除或修改权限', // 1012 data.reason=super_admin（D7-13）
  },
  en: {
    ruleBuiltin: 'Built-in · enforced',
    ruleAnchorTip: 'Threshold is set in system parameter {key}', // 本计划定稿
    ruleAlwaysOn: 'Built-in rules are always in effect', // 本计划定稿
    stOffline: 'Offline',
    cSortOrder: 'Order',
    ticketThread: 'Thread',
    senderUser: 'User', // 本计划定稿
    senderAdmin: 'Support {account}', // 本计划定稿
    replyPh: 'Write a reply', // 本计划定稿
    aReply: 'Reply', // 本计划定稿
    toastReplied: 'Reply sent',
    admBody: 'Body',
    admPublishedAt: 'Published at',
    admSubmitter: 'Submitted by',
    admRefTx: 'Related transaction',
    admErrSortOrder: 'Order must be an integer of 0 or more',
    st2faUnbound: 'Not bound',
    reset2faTitle: 'Reset 2FA', // 本计划定稿
    reset2faText: "This clears the admin's authenticator binding and signs out all of their sessions; they must re-bind 2FA at next sign-in.", // 本计划定稿
    toastReset2fa: '2FA reset; the admin must re-enroll at next login', // 本计划定稿（W-7）
    admErrPwdPolicy: 'Password must be 8–20 characters with both letters and digits',
    admErrLastSuper: 'At least one active super admin must remain',
    errRoleInUse: 'This role still has members and cannot be deleted', // 本计划定稿
    admErrSuperLocked: 'The super admin role cannot be deleted or have its permissions changed',
  },
};

// TD-805：覆盖原型字典的键（06 [改写 key]）
export const REWRITES_PLATFORM: readonly string[] = [];
